import * as React from 'react';

const AppLoading = () => <div style={{ color: 'red' }}>loading...</div>;

export { AppLoading };
